import { useEffect, useState } from "react";

interface Stats {
  totalUploads: number;
  uniqueUsers: number;
  totalViews: number;
}

const formatNumber = (n: number): string =>
  n >= 1000 ? n.toLocaleString() : String(n);

export function LiveStats() {
  const [stats, setStats] = useState<Stats | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetch("/api/stats")
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error("HTTP " + r.status))))
      .then((data: Stats) => {
        if (!cancelled) setStats(data);
      })
      .catch(() => {
        // Silent fail — the section just doesn't render
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!stats || stats.totalUploads === 0) return null;

  return (
    <div className="livestats" role="region" aria-label="Live mycv.now usage stats">
      <div className="livestats__item">
        <div className="livestats__num">{formatNumber(stats.totalUploads)}</div>
        <div className="livestats__lbl">Resumes shared</div>
      </div>
      <div className="livestats__sep" aria-hidden="true" />
      <div className="livestats__item">
        <div className="livestats__num">{formatNumber(stats.totalViews)}</div>
        <div className="livestats__lbl">Views tracked</div>
      </div>
      <div className="livestats__sep" aria-hidden="true" />
      <div className="livestats__item">
        <div className="livestats__num">{formatNumber(stats.uniqueUsers)}</div>
        <div className="livestats__lbl">Active users</div>
      </div>
    </div>
  );
}
